import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateClient,
    getDetailClient,
    getPageClients,
} from '../ClientEndPoint'

export const useDetailClient = (requestorId, id, enabled = true) => {
    const {clientKeys} = QueryKeyManager(QueryKeyTypes.client, requestorId)
    return useQuery({
        queryKey: clientKeys.detail({requestorId, id}),
        queryFn: () => getDetailClient(requestorId, id),
        enabled: !!requestorId && !!id && !!enabled,
    })
}

export const usePageClients = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {clientKeys} = QueryKeyManager(QueryKeyTypes.client, requestorId)

    return useQuery({
        queryKey: clientKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageClients(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useClientCRUD = (type, requestorId) => {
    const {clientKeys} = QueryKeyManager(QueryKeyTypes.client, requestorId)
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateClient(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Client Update Successfully !!',
                    )
                }
            }
        },
    })
}
